import {
  AUTH_ERROR,
  AUTH_USER,
  FETCH_ORDERS_REQ,
  FETCH_ORDERS_RES,
  FETCH_REMAKE_REPORT_REQ,
  FETCH_REMAKE_REPORT_RES,
  FETCH_REPORT_REQ,
  FETCH_REPORT_RES,
  FETCH_THROUGHPUT_REPORT_REQ,
  FETCH_THROUGHPUT_REPORT_RES,
  FETCH_TIP_REPORT_REQ,
  FETCH_TIP_REPORT_RES,
  RECEIVE_WS_ORDERS,
  SUBMIT_REMAKE_FAIL,
  SUBMIT_REMAKE_REQ,
  SUBMIT_REMAKE_SUCCESS,
  TIMER_START,
  TIMER_STOP,
  TIMER_TICK,
  TOGGLE_SIDENAV,
  UPDATE_ORDER_COMPLETED_TIME,
  UPDATE_ORDER_DELIVERED_TIME,
} from './types';

export const signin = (formProps, callback) => async (dispatch) => {
  try {
    const response = await fetch(`/api/signin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formProps),
    });

    const result = await response.json();

    if (!response.ok) {
      dispatch({ type: AUTH_ERROR, payload: result.error });
    } else {
      dispatch({ type: AUTH_USER, payload: result.token });
      localStorage.setItem('token', result.token);
      callback();
    }
  } catch (e) {
    console.error('Error during sign in:', e);
    dispatch({ type: AUTH_ERROR, payload: `Unable to sign in.` });
  }
};

export const signout = () => {
  localStorage.removeItem('token');

  return {
    type: AUTH_USER,
    payload: '',
  };
};

export const fetchOrders = (start) => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_REQ });

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`/api/orders?start=${start}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const orders = await response.json();

    dispatch({
      type: FETCH_ORDERS_RES,
      payload: orders,
    });
  } catch (error) {
    console.error('Error fetching orders:', error);
    dispatch({ type: FETCH_ORDERS_RES, payload: [] });
  }
};

export const fetchReport =
  (start, end, orderType = 'completed') =>
  async (dispatch) => {
    dispatch({ type: FETCH_REPORT_REQ });

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/orders?start=${start}&end=${end}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const orders = await response.json();

      dispatch({
        type: FETCH_REPORT_RES,
        payload: orders,
        orderType: orderType,
      });
    } catch (error) {
      console.error('Error fetching report:', error);
      // You might want to dispatch an error action here
    }
  };

export const toggleSidenav = (status) => {
  return {
    type: TOGGLE_SIDENAV,
    payload: status,
  };
};

export const receiveWebSocketOrders = (orders) => {
  return {
    type: RECEIVE_WS_ORDERS,
    payload: orders,
  };
};

export const updateOrderCompletedTime = (order) => {
  if (order.completed_at) {
    order.completed_at = null;
  } else {
    const time = new Date();
    order.completed_at = time.toISOString();
  }

  const token = localStorage.getItem('token');
  fetch(`/api/orders/${order._id}/completed-time`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      completed_at: order.completed_at,
    }),
  }).catch((error) => {
    console.error('Error updating order completed time:', error);
  });

  return {
    type: UPDATE_ORDER_COMPLETED_TIME,
    payload: order,
  };
};

export const updateOrderDeliveredTime = (order) => {
  if (order.delivered_at) {
    order.delivered_at = null;
  } else {
    const time = new Date();
    order.delivered_at = time.toISOString();
  }

  const token = localStorage.getItem('token');
  fetch(`/api/orders/${order._id}/delivered-time`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      delivered_at: order.delivered_at,
    }),
  }).catch((error) => {
    console.error('Error updating order delivered time:', error);
  });

  return {
    type: UPDATE_ORDER_DELIVERED_TIME,
    payload: order,
  };
};

let timer = null;
const tick = () => ({ type: TIMER_TICK, payload: Date.now() });

export const startTimer = () => (dispatch) => {
  clearInterval(timer);
  timer = setInterval(() => dispatch(tick()), 1000);
  dispatch({ type: TIMER_START });
  dispatch(tick());
};

export const stopTimer = () => {
  clearInterval(timer);
  return { type: TIMER_STOP };
};

export const fetchRemakeReport = (start, end) => async (dispatch) => {
  dispatch({ type: FETCH_REMAKE_REPORT_REQ });

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`/api/remakes?start=${start}&end=${end}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const orders = await response.json();

    dispatch({
      type: FETCH_REMAKE_REPORT_RES,
      payload: orders,
    });
  } catch (error) {
    console.error('Error fetching remake report:', error);
  }
};

export const submitRemake =
  (orderId, lineItemId, remakeData) => async (dispatch) => {
    dispatch({ type: SUBMIT_REMAKE_REQ });

    if (!remakeData.reason) {
      dispatch({
        type: SUBMIT_REMAKE_FAIL,
        payload: 'Please select a reason',
      });
      if (window.M && window.M.toast) {
        window.M.toast({
          html: 'Please select a reason',
          classes: 'red',
        });
      }
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const time = new Date();
      const response = await fetch(
        `/api/orders/${orderId}/line-items/${lineItemId}/remake`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...remakeData,
            created_at: time.toISOString(),
          }),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to submit remake');
      }

      const data = await response.json();

      dispatch({
        type: SUBMIT_REMAKE_SUCCESS,
        payload: data,
      });

      dispatch(
        fetchOrders(new Date().toISOString().split('T')[0] + 'T00:00:00'),
      );

      if (window.M && window.M.toast) {
        window.M.toast({ html: 'Remake recorded successfully' });
      }
    } catch (error) {
      dispatch({
        type: SUBMIT_REMAKE_FAIL,
        payload: error.message,
      });
      if (window.M && window.M.toast) {
        window.M.toast({
          html: `Error: ${error.message}`,
          classes: 'red',
        });
      }
    }
  };

export const fetchTipReport = (start, end) => async (dispatch) => {
  dispatch({ type: FETCH_TIP_REPORT_REQ });

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`/api/tip-report?start=${start}&end=${end}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    dispatch({
      type: FETCH_TIP_REPORT_RES,
      payload: data.cashiers,
    });
  } catch (error) {
    console.error('Error fetching tip report:', error);
  }
};

export const fetchThroughputReport = (start, end) => async (dispatch) => {
  dispatch({ type: FETCH_THROUGHPUT_REPORT_REQ });

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(
      `/api/throughput-report?start=${start}&end=${end}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    dispatch({
      type: FETCH_THROUGHPUT_REPORT_RES,
      payload: data.heatmap,
    });
  } catch (error) {
    console.error('Error fetching throughput report:', error);
  }
};
